import isNullOrWhitespace from "./isNullOrWhitespace";

export function toISODate(dateString) {
    if (isNullOrWhitespace(dateString)) {
        return '';
    }

    const [yyyy, MM, dd] = dateString.split('-');
    return `${yyyy}-${MM}-${dd}T00:00:00`;
}

export default function toInputDate(dateString) {
    if (isNullOrWhitespace(dateString)) {
        return '';
    }

    const [yyyy, MM, dd] = (dateString.split('T')[0]).split('-');

    return `${yyyy}-${MM}-${dd}`;
}